import { Injectable } from '@angular/core';
import { VerticalTypeEnum } from './vertical-type.enum';
import { AuthService } from '../../shared/auth/auth.service';
import { AuthUserInfo } from '../../shared/auth/auth-user-info.model';

@Injectable({
  providedIn: 'root',
})
export class VerticalService {
  public constructor(private _authService: AuthService) {}

  public async GetCurrentUserVerticalType(): Promise<VerticalTypeEnum> {
    let userInfo = await this._authService.getUserInfo();
    let vertTypeNum = 0;
    let verticalType: VerticalTypeEnum;
    if (userInfo) {
      // the property somehow has a space in it
      if (userInfo.wli_associnfo_associationverticaltypeid) verticalType = +userInfo.wli_associnfo_associationverticaltypeid;
      else verticalType = +userInfo['wli_associnfo_ associationverticaltypeid'];
    }
    // assume chamber
    else verticalType = VerticalTypeEnum.ChamberOfCommerce;

    return Promise.resolve(verticalType);
  }
}
